import React, {useState} from 'react';
import styles from './EventFilters.module.css';
import {
  Paper,
  Toolbar,
  IconButton,
  Slider,
  Typography,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import CustomPicker from './CustomPicker';
import CustomModal from './CustomModal';

import {filters} from '../../models/Filters';
import {
  GROUP_EVENT_OPTIONS_SORTED,
  SORT_OPTIONS,
  DATE_OPTIONS,
  VIRTUAL_EVENT_SUBTYPES,
  GROUP_OPTIONS,
  VIRTUAL_GROUP_OPTIONS,
  VIRTUAL_TIME_OPTIONS,
  WORKSPACE_ONLY_OPTIONS,
} from '../../../../shared/constants/EventFilters';
import XIcon from '../svgs/XIcon';
import CustomButton from '../CustomButton';
import {
  logDateFilter,
  logDistanceFilter,
  logSortFilter,
} from '../../../../shared/models/Analytics';
import {
  DEFAULT_LOCAL_OPTIONS,
  DEFAULT_VIRTUAL_OPTIONS,
} from '../../../../shared/constants/DefaultFilters';
import {
  EVENT_TAB_TYPES,
  FILTER_NAV_TABS,
} from '../../../../shared/constants/EventTabs';
import ReusableTabs from '../ReusableTabs';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {
  pickEventConfigValue,
  pickProjectConfigValue,
} from '../../../../shared/utils/ProjectConfigPicker';

const _styles = {
  root: {
    flexGrow: 1,
  },
  toolbar: {
    backgroundColor: 'var(--primary)',
    height: 64,
    position: 'relative',
    justifyContent: 'space-between',
  },
  menuButton: {
    marginRight: '15px',
    color: 'var(--white)',
  },
  title: {
    color: 'var(--white)',
    textTransform: 'capitalize',
    textAlign: 'center',
    // title should always center, regardless of length of siblings
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    fontWeight: 'bold',
  },
  slider: {
    color: 'var(--primary)',
    width: 'calc(100% - 40px)',
    left: '20px',
  },
  button: {
    backgroundColor: 'var(--primary)',
    color: 'var(--white)',
    width: '70%',
    height: '50px',
    '&:hover': {
      backgroundColor: 'var(--primary)',
    },
  },
  reset: {
    color: 'var(--white)',
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
};

const DISTANCE_OPTIONS = [
  {
    label: projectConfig.distanceUnits === 'mi' ? '25 MI' : '40 KM',
    slug: '25-miles',
    value: 25,
  },
  {
    label: projectConfig.distanceUnits === 'mi' ? '50 MI' : '80 KM',
    slug: '50-miles',
    value: 50,
  },
  {
    label: projectConfig.distanceUnits === 'mi' ? '100 MI' : '160 KM',
    slug: '100-miles',
    value: 100,
  },
  {
    label: projectConfig.distanceUnits === 'mi' ? '250 MI' : '400 KM',
    slug: '250-miles',
    value: 250,
  },
];

const FILTER_NAV_TABS_KEYS = ['all', 'group', 'member'];

const hasGroups = pickProjectConfigValue('hasGroups');

const EventFilters = ({classes, onCloseFilters, activeTab}) => {
  const [
    distanceSliderSelectedValue,
    setdistanceSliderSelectedValue,
  ] = useState(
    DISTANCE_OPTIONS.filter((opt) => opt.slug === filters.eventDistance)[0],
  );
  const [datePickerSelectedValue, setdatePickerSelectedValue] = useState(
    activeTab === EVENT_TAB_TYPES.local
      ? filters.eventDate
      : filters.virtualEventDate || DEFAULT_VIRTUAL_OPTIONS.virtualEventDate,
  );
  const [datePickerIsOpen, setdatePickerIsOpen] = useState(false);
  const [sortPickerSelectedValue, setsortPickerSelectedValue] = useState(
    activeTab === EVENT_TAB_TYPES.local
      ? filters.sortBy
      : filters.virtualSortBy || DEFAULT_VIRTUAL_OPTIONS.virtualSortBy,
  );
  const [sortPickerIsOpen, setsortPickerIsOpen] = useState(false);

  const [
    workspaceOnlyPickerSelectedValue,
    setWorkspaceOnlyPickerSelectedValue,
  ] = useState(
    activeTab === EVENT_TAB_TYPES.local
      ? filters.workspaceOnly || DEFAULT_LOCAL_OPTIONS.workspaceOnly
      : filters.virtualWorkspaceOnly ||
          DEFAULT_VIRTUAL_OPTIONS.virtualWorkspaceOnly,
  );
  const [workspaceOnlyPickerIsOpen, setworkspaceOnlyPickerIsOpen] = useState(
    false,
  );

  const [activityModalSelectedValue, setactivityModalSelectedValue] = useState(
    activeTab === EVENT_TAB_TYPES.local
      ? filters.eventCategory || 'all-activities'
      : filters.virtualEventCategory || 'all-activities',
  );
  const [activityModalIsOpen, setactivityModalIsOpen] = useState(false);
  const [
    virtualSubTypeSelectedValue,
    setVirtualSubTypeSelectedValue,
  ] = useState(filters.virtualSubtype || 'all');
  const [virtualSubTypeIsOpen, setVirtualSubTypeIsOpen] = useState(false);
  const [activeFilterTab, setActiveFilterTab] = useState(
    FILTER_NAV_TABS_KEYS.indexOf(filters.eventFilterNavTab || 0), // to avoid using map each time
  );
  const [activeGroupOption, setActiveGroupOption] = useState(
    filters.eventGroupOption || DEFAULT_LOCAL_OPTIONS.eventGroupOption,
  );
  const [activeGroupOptionIsOpen, setActiveGroupOptionIsOpen] = useState(false);
  const [activeVirtualGroupOption, setActiveVirtualGroupOption] = useState(
    filters.virtualEventGroupOption ||
      DEFAULT_VIRTUAL_OPTIONS.virtualEventGroupOption,
  );
  const [
    activeVirtualGroupOptionIsOpen,
    setActiveVirtualGroupOptionIsOpen,
  ] = useState(false);

  const [virtualTimeValue, setVirtualTimeValue] = useState(
    filters.virtualTime || DEFAULT_VIRTUAL_OPTIONS.virtualTime,
  );

  const [virtualTimeIsOpen, setVirtualTimeIsOpen] = useState(false);

  const datePickerHandler = () => {
    setdatePickerIsOpen((prevState) => !prevState);
  };
  const datePickerSelectHandler = (value) => setdatePickerSelectedValue(value);

  const sortPickerHandler = () => {
    setsortPickerIsOpen((prevState) => !prevState);
  };
  const sortPickerSelectHandler = (value) => setsortPickerSelectedValue(value);

  const workspaceOnlyPickerHandler = () => {
    setworkspaceOnlyPickerIsOpen((prevState) => !prevState);
  };
  const workspaceOnlyPickerSelectHandler = (value) =>
    setWorkspaceOnlyPickerSelectedValue(value);

  const activityModalHandler = () => {
    setactivityModalIsOpen((prevState) => !prevState);
  };
  const activityModalSelectHandler = (value) => {
    setactivityModalSelectedValue(
      typeof value === 'string' ? value : 'all-activities',
    );
    setactivityModalIsOpen(false);
  };
  const virtualSubTypeSelectHandler = (value) =>
    setVirtualSubTypeSelectedValue(value);
  const virtualSubTypePickerHandler = () =>
    setVirtualSubTypeIsOpen((prevState) => !prevState);

  const virtualTimeSelectHandler = (value) => setVirtualTimeValue(value);
  const virtualTimePickerHandler = () =>
    setVirtualTimeIsOpen((prevState) => !prevState);

  const distanceSliderChangeHandler = (_, value) => {
    const newValue = DISTANCE_OPTIONS.filter((opt) => opt.value === value)[0];
    setdistanceSliderSelectedValue(newValue);
  };

  const activeGroupOptionHandler = () => {
    setActiveGroupOptionIsOpen((prevState) => !prevState);
  };

  const activeVirtualGroupOptionHandler = () => {
    setActiveVirtualGroupOptionIsOpen((prevState) => !prevState);
  };

  const handleAnalytics = () => {
    if (sortPickerSelectedValue !== filters.sortBy) logSortFilter();
    if (datePickerSelectedValue !== filters.eventDate) logDateFilter();
    if (distanceSliderSelectedValue.slug !== filters.eventDistance)
      logDistanceFilter();
    // TODO: Add analytics for Virtual Event Type if already not exists
  };

  const applyFiltersHandler = async () => {
    handleAnalytics();
    if (activeTab === EVENT_TAB_TYPES.local) {
      await filters.setFilter({
        workspaceOnly: workspaceOnlyPickerSelectedValue,
        eventDistance: distanceSliderSelectedValue.slug,
        eventDate: datePickerSelectedValue,
        sortBy: sortPickerSelectedValue,
        eventCategory: activityModalSelectedValue,
        eventFilterNavTab: FILTER_NAV_TABS_KEYS[activeFilterTab],
        eventGroupOption: activeGroupOption,
      });
    } else if (activeTab === EVENT_TAB_TYPES.virtual) {
      await filters.setFilter({
        virtualWorkspaceOnly: workspaceOnlyPickerSelectedValue,
        virtualEventDate: datePickerSelectedValue,
        virtualSortBy: sortPickerSelectedValue,
        virtualEventCategory: activityModalSelectedValue,
        virtualSubtype: virtualSubTypeSelectedValue,
        virtualEventGroupOption: activeVirtualGroupOption,
        virtualTime: virtualTimeValue,
      });
    }
    filters.getFilters();
    onCloseFilters(true);
  };

  const resetFilters = () => {
    if (activeTab === EVENT_TAB_TYPES.local) {
      setdistanceSliderSelectedValue({
        label: '50 MI',
        slug: DEFAULT_LOCAL_OPTIONS.eventDistance,
        value: 50,
      });
      setdatePickerSelectedValue(DEFAULT_LOCAL_OPTIONS.eventDate);
      setsortPickerSelectedValue(DEFAULT_LOCAL_OPTIONS.sortBy);
      setactivityModalSelectedValue(DEFAULT_LOCAL_OPTIONS.eventCategory);
      setActiveFilterTab(
        FILTER_NAV_TABS_KEYS.indexOf(DEFAULT_LOCAL_OPTIONS.eventFilterNavTab),
      );
      setActiveGroupOption(DEFAULT_LOCAL_OPTIONS.eventGroupOption);
      setWorkspaceOnlyPickerSelectedValue(DEFAULT_LOCAL_OPTIONS.workspaceOnly);
    } else if (activeTab === EVENT_TAB_TYPES.virtual) {
      setWorkspaceOnlyPickerSelectedValue(
        DEFAULT_VIRTUAL_OPTIONS.virtualWorkspaceOnly,
      );
      setVirtualSubTypeSelectedValue(DEFAULT_VIRTUAL_OPTIONS.virtualSubtype);
      setdatePickerSelectedValue(DEFAULT_VIRTUAL_OPTIONS.virtualEventDate);
      setsortPickerSelectedValue(DEFAULT_VIRTUAL_OPTIONS.virtualSortBy);
      setactivityModalSelectedValue(
        DEFAULT_VIRTUAL_OPTIONS.virtualEventCategory,
      );
      setActiveVirtualGroupOption(
        DEFAULT_VIRTUAL_OPTIONS.virtualEventGroupOption,
      );
      setVirtualTimeValue(DEFAULT_VIRTUAL_OPTIONS.virtualTime);
    }
  };

  const isVirtualTab = activeTab === EVENT_TAB_TYPES.virtual;
  const eventTypes = {
    'all-activities': {display: 'All Activities', slug: null},
    ...pickEventConfigValue('eventCategories', GROUP_EVENT_OPTIONS_SORTED),
  };

  return (
    <div className={styles.container}>
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div onClick={() => onCloseFilters(false)}>
            <IconButton className={classes.menuButton} color="inherit">
              <XIcon tintColor={'var(--white)'} />
            </IconButton>
          </div>
          <Typography variant="h6" className={classes.title}>
            Event Filters
          </Typography>
          <IconButton
            edge="end"
            className={classes.menuButton}
            color="inherit"
            onClick={resetFilters}>
            <Typography variant="h6" className={classes.reset}>
              Reset
            </Typography>
          </IconButton>
        </Toolbar>
      </Paper>
      {activeTab === EVENT_TAB_TYPES.local &&
        hasGroups &&
        projectConfig.allowsLocalEventsOutsideGroups && (
          <div className={styles.tabsContainer}>
            <ReusableTabs
              selectedValue={activeFilterTab}
              values={FILTER_NAV_TABS.map(({name}) => name)}
              onChangeHandler={setActiveFilterTab}
            />
          </div>
        )}
      <div className={styles.contentScroll}>
        <div className={styles.contentContainer}>
          {hasGroups &&
            ((activeFilterTab === 1 && Object.keys(GROUP_OPTIONS).length > 0) ||
              (isVirtualTab && Object.keys(VIRTUAL_GROUP_OPTIONS).length > 0) ||
              (activeFilterTab === 0 &&
                !projectConfig.allowsLocalEventsOutsideGroups &&
                Object.keys(GROUP_OPTIONS).length > 0)) && (
              <CustomPicker
                title={'Group'}
                isOpen={
                  isVirtualTab
                    ? activeVirtualGroupOptionIsOpen
                    : activeGroupOptionIsOpen
                }
                items={isVirtualTab ? VIRTUAL_GROUP_OPTIONS : GROUP_OPTIONS}
                selectedValue={
                  isVirtualTab ? activeVirtualGroupOption : activeGroupOption
                }
                pickerHandler={() =>
                  isVirtualTab
                    ? activeVirtualGroupOptionHandler()
                    : activeGroupOptionHandler()
                }
                onSelect={(slug) =>
                  isVirtualTab
                    ? setActiveVirtualGroupOption(slug)
                    : setActiveGroupOption(slug)
                }
              />
            )}
          {activeTab === EVENT_TAB_TYPES.local && (
            <>
              <p className={`formLabel ${styles.distanceLabel}`}>Distance</p>
              <Slider
                value={distanceSliderSelectedValue.value}
                className={classes.slider}
                aria-labelledby="discrete-slider-restrict"
                step={null}
                valueLabelDisplay="off"
                marks={DISTANCE_OPTIONS}
                min={25}
                max={250}
                onChange={distanceSliderChangeHandler}
              />
            </>
          )}
          {activeTab === EVENT_TAB_TYPES.virtual && (
            <CustomPicker
              title={'Duration'}
              isOpen={virtualTimeIsOpen}
              items={VIRTUAL_TIME_OPTIONS}
              selectedValue={virtualTimeValue}
              pickerHandler={virtualTimePickerHandler}
              onSelect={virtualTimeSelectHandler}
            />
          )}
          {Object.keys(VIRTUAL_EVENT_SUBTYPES)?.length > 0 &&
            activeTab === EVENT_TAB_TYPES.virtual && (
              <CustomPicker
                title={'Virtual Event Type'}
                isOpen={virtualSubTypeIsOpen}
                items={VIRTUAL_EVENT_SUBTYPES}
                selectedValue={virtualSubTypeSelectedValue}
                pickerHandler={virtualSubTypePickerHandler}
                onSelect={virtualSubTypeSelectHandler}
              />
            )}
          <CustomPicker
            title={'Date'}
            isOpen={datePickerIsOpen}
            items={DATE_OPTIONS}
            selectedValue={datePickerSelectedValue}
            pickerHandler={datePickerHandler}
            onSelect={datePickerSelectHandler}
          />

          <CustomPicker
            title={'Sort By'}
            isOpen={sortPickerIsOpen}
            items={SORT_OPTIONS}
            selectedValue={sortPickerSelectedValue}
            pickerHandler={sortPickerHandler}
            onSelect={sortPickerSelectHandler}
          />
          <CustomModal
            title={'Activity Category'}
            isOpen={activityModalIsOpen}
            items={eventTypes}
            selectedValue={activityModalSelectedValue}
            modalHandler={activityModalHandler}
            onSelect={activityModalSelectHandler}
          />
          {projectConfig.hasWorkspaces &&
            Object.keys(WORKSPACE_ONLY_OPTIONS).length > 0 && (
              <CustomPicker
                title={'My Company Events'}
                isOpen={workspaceOnlyPickerIsOpen}
                items={WORKSPACE_ONLY_OPTIONS}
                selectedValue={workspaceOnlyPickerSelectedValue}
                pickerHandler={workspaceOnlyPickerHandler}
                onSelect={workspaceOnlyPickerSelectHandler}
              />
            )}
          <div className={styles.buttonContainer} onClick={applyFiltersHandler}>
            <CustomButton label={'Apply'} buttonStyle={'primary'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(_styles)(EventFilters);
